import {storeToRefs} from "pinia";
import {useClientStorage, useRubricArticleStore, useStatesStorage} from "@/stores/store";
import {loadArticleAJ, loadPageDataAJ} from "@/api/http";

import {loadLocale} from "@/shared/services/translate";
import {UpdateTitleAndMeta} from "@/shared/services/util";


export const initPage = (to, from, getFullData = false) => {
    //console.log('initPage 1');

    //const statesStorage = useStatesStorage();
    //const { viewStates } = storeToRefs(statesStorage);

    const clientStorage = useClientStorage();
    const { clientObj } = storeToRefs(clientStorage);

    //const translateStorage = useTranslateStorage();
    //const { language_strings } = storeToRefs(translateStorage);

    //console.log('language_strings', language_strings)
    const rubricArticleStore = useRubricArticleStore();
    const { rubrics, articles } = storeToRefs(rubricArticleStore);

    if(!Object.keys(articles.value).length && !Object.keys(rubrics.value).length) {

        return loadPageDataAJ(getFullData).then(r => {
            if(r.ok)
            {
                articles.value = r.articles;

                rubrics.value = r.rubrics;
                clientObj.value = r.client;

                return clientObj.value.lang;
            }
            else
            {
                throw new Error(r.error);
            }

            /*
            loadLocale(lang).then(r => {
                language_strings.value = r.language_strings
            });
            return {resultInitView: true};
             */

        }).then(lang => loadLocale(lang)).catch((error) => {
            alert(error)
            return {resultInitView: false};
        });
    }
    else {
        //console.log('initPage 5');
        return Promise.resolve({resultInitView: true});
    }
}

export const InitStates =() => {
    const statesStorage = useStatesStorage();
    const { viewStates } = storeToRefs(statesStorage);

    viewStates.value.show_preloader_spinner = false;
    viewStates.value.show_preloader_article_spinner = true;
    viewStates.value.save_in_process = false;
}

export const InitArticle = (rubric_id, article_id, route) => {
    InitStates();

    const statesStorage = useStatesStorage();
    const { viewStates } = storeToRefs(statesStorage);

    const rubricArticleStore = useRubricArticleStore();

    const { article } = storeToRefs(rubricArticleStore);

    loadArticleAJ(rubric_id, article_id).then(r => {
        if(r.ok)
        {
            viewStates.value.show_preloader_article_spinner = false;
            article.value = r.article;

            UpdateTitleAndMeta(route);
        }
        else
        {
            throw new Error(r.data.error)
        }
    }).catch((error) => {
        alert(error)
        return false;
    });
}
